import React from "react";
import _ from "lodash";
import ActivityForm from "./ActivityForm";
import { useMutation } from "@tanstack/react-query";
import { createResource } from "../../../services/ReactQuery/reactQueryService";
import { UseFormProps } from "../../../hooks/useForm";
import { useCurrentEditor } from "@tiptap/react";
import LegalbirdTipTapEditorProvider from "../../LbEditor/LegalbirdTipTapEditorProvider";
import { getEditorHtml } from "../../../services/Editor/editorFunctions";
import { getActivityData } from "../../../services/Activities/activityTypes";
import { ProductUnion } from "../../../types/ProductUnion";
import dayjs from "dayjs";

type CreateActivityProps = {
  closeDialog: Function;
  product: ProductUnion;
  caseId: string;
  updateActivities: () => void;
  defaultAssignedUser?: string;
};

const CreateActivity = (props: CreateActivityProps) => {
  return (
    <LegalbirdTipTapEditorProvider placeholder={"Notiz"}>
      <CreateActivityInner {...props} />
    </LegalbirdTipTapEditorProvider>
  );
};

const CreateActivityInner = ({
  closeDialog,
  product,
  caseId,
  updateActivities,
  defaultAssignedUser,
}: CreateActivityProps) => {
  const createMutation = useMutation({
    mutationFn: createResource
  });
  const { editor } = useCurrentEditor();

  const onSubmit: UseFormProps["onSubmit"] = async ({ values }) => {
    let activityData = _.merge({}, values);
    activityData.dueTime = activityData.dueTime !== "" ? activityData.dueTime : "allDay";
    activityData.case = caseId;
    activityData.note = getEditorHtml(editor, true);
    activityData.mandatory = activityData.mandatory === "true";
    activityData.isAiDelegatable = getActivityData(product.productClassName, activityData.type)?.isAiDelegatable ?? false;
    await createMutation.mutateAsync({ uri: "activities", data: activityData });
    updateActivities();
    closeDialog();
  };

  const baseValues = {
    type: "no_type",
    subject: "",
    dueDate: dayjs(),
    dueTime: "",
    mandatory: "false",
    assignedUser: defaultAssignedUser || "",
  };

  return (
    <ActivityForm
      initialValues={baseValues}
      onSubmit={onSubmit}
      closeDialog={closeDialog}
      product={product}
      productClassName={product.productClassName}
      open={true}
    />
  );
};

export default CreateActivity;
